// dependencies
import React from "react";
import PropTypes from "prop-types";

// style
import css from "../Table.styl";

const Cell = (props) => {
	const { children, className } = props;
	return <div className={`${css.Cell} ${className}`}>{children}</div>;
};

Cell.propTypes = {
	className: PropTypes.string,
	children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
};

Cell.defaultProps = {
	className: "",
	children: null,
};

export default Cell;
